import * as bootstrap from 'bootstrap';
import jquery from 'jquery';

window.$ = window.jQuery = window.jquery = jquery;

window.bootstrap = bootstrap

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


$.fn.modalFormSubmit = function (options) {

    let settings = $.extend({
        prePost                 :       null,
        success                 :       null,
        validationError         :       null,
        error                   :       null,
    }, options );
    $(this).on('submit', function(event) {
        event.preventDefault();

        let form = $(event.target);
        let modalPopup = form.closest('div.modal');
        let submitButton = form.find('input[type=submit]');

        submitButton.attr('disabled', 'disabled');

        if (typeof settings.prePost == 'function') {
            settings.prePost.call(this);
        }

        $.ajax({
            type: 'POST',
            url : form.attr('action'),
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data : form.serializeArray(),
            success: function (data, textStatus, jqXHR) {
                if (data.status.toUpperCase() === 'SUCCESS') {
                    if (typeof settings.success == 'function') {
                        settings.success.call(this, data);
                        modalPopup.modal('hide');
                    }
                } else if (data.status.toUpperCase() === 'ERROR') {
                    if (typeof settings.validationError == 'function') {
                        settings.validationError.call(this, data);
                        submitButton.removeAttr('disabled', 'disabled');
                    }
                } else {
                    if (console) {
                        console.error('Invalid status used. Please use "success" or "error".');
                    }
                    submitButton.removeAttr('disabled', 'disabled');
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (settings.error != undefined) {
                    settings.error.call(this, jqXHR);
                }
                submitButton.removeAttr('disabled', 'disabled');
            }
        });
    });
};
